import React from 'react';

// Ruler component for pixel-perfect positioning
export function CanvasRuler({ orientation, length, scale, offset = 0 }) {
  const isHorizontal = orientation === 'horizontal';
  const tickInterval = 50;
  const minorTicks = 10;

  const majorTicks = [];
  const minorTicksList = [];

  for (let i = 0; i <= length; i += tickInterval) majorTicks.push(i);
  for (let i = 0; i <= length; i += minorTicks) {
    if (i % tickInterval !== 0) minorTicksList.push(i);
  }

  return (
    <div
      className={`bg-muted/40 border-border/30 flex-shrink-0 select-none ${isHorizontal ? 'border-b h-5' : 'border-r w-5'}`}
      style={{
        [isHorizontal ? 'width' : 'height']: length * scale + offset,
        [isHorizontal ? 'marginLeft' : 'marginTop']: offset,
      }}
    >
      <svg
        width={isHorizontal ? length * scale : 20}
        height={isHorizontal ? 20 : length * scale}
        className="text-muted-foreground/70"
      >
        {majorTicks.map(pos => (
          <g key={`major-${pos}`}>
            {isHorizontal ? (
              <>
                <line x1={pos * scale} y1={12} x2={pos * scale} y2={20} stroke="currentColor" strokeWidth={1} />
                <text x={pos * scale + 2} y={10} fontSize={8} fill="currentColor">{pos}</text>
              </>
            ) : (
              <>
                <line x1={12} y1={pos * scale} x2={20} y2={pos * scale} stroke="currentColor" strokeWidth={1} />
                <text x={2} y={pos * scale + 3} fontSize={8} fill="currentColor" style={{ writingMode: 'vertical-rl' }}>{pos}</text>
              </>
            )}
          </g>
        ))}
        {minorTicksList.map(pos => (
          <g key={`minor-${pos}`}>
            {isHorizontal ? (
              <line x1={pos * scale} y1={16} x2={pos * scale} y2={20} stroke="currentColor" strokeWidth={0.5} opacity={0.5} />
            ) : (
              <line x1={16} y1={pos * scale} x2={20} y2={pos * scale} stroke="currentColor" strokeWidth={0.5} opacity={0.5} />
            )}
          </g>
        ))}
      </svg>
    </div>
  );
}

export function AlignmentGuide({ position, orientation, scale, color = '#3b82f6' }) {
  if (position === null) return null;
  const isHorizontal = orientation === 'horizontal';
  return (
    <div
      className="absolute pointer-events-none z-50"
      style={{
        [isHorizontal ? 'top' : 'left']: position * scale,
        [isHorizontal ? 'left' : 'top']: 0,
        [isHorizontal ? 'right' : 'bottom']: 0,
        [isHorizontal ? 'height' : 'width']: 1,
        background: color,
        boxShadow: `0 0 4px ${color}`,
      }}
    />
  );
}
